export default ({ app }) => {
    app.router.beforeEach((to, from, next) => {
        if (to.name === 'home' || to.name === 'goodsList' || to.name === 'collection' || to.name === 'similar') {
            app.$updateTrackUUID()
            app.$cookies.set('new_track_uuid', app.$cookies.get('track_uuid'))
        }
        next()
    })
}
